import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class NotificationsIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20"><path fillRule="evenodd" d="M7.313 2.388v-.752C7.312.733 8.07 0 9 0c.932 0 1.687.73 1.687 1.636v.752c2.913.727 5.063 3.29 5.063 6.34v4.363c0 .403.335.727.749.727.826 0 1.501.65 1.501 1.455v1.092a.371.371 0 0 1-.376.362H.376A.368.368 0 0 1 0 16.365v-1.092c0-.801.672-1.455 1.501-1.455a.74.74 0 0 0 .749-.727V8.727c0-3.05 2.152-5.613 5.063-6.34zm-.938 15.067h5.25C11.625 18.86 10.45 20 9 20s-2.625-1.14-2.625-2.545z"/></svg>
        )
    }
}

export default withCssClassName(NotificationsIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/notifications-icon.js